import React from 'react';

// material ui
// import FormControl from '@material-ui/core/FormControl';
// import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
//import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
//import InputLabel from '@material-ui/core/InputLabel';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
//import Autocomplete from 'react-autocomplete'

import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

export default class FilterItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedFilterKey: this.props.filter.key || '', // this refers to the selected filter with key as the id
      selectedValue: this.props.filter.value || '', // while this is the value that is applied with the filter
      filters: this.props.filters || []
    };
  }
  _updateFilterValue(selectedObject) {

    this.props.onSelect({ key: this.state.selectedFilterKey, value: selectedObject})
  }
  _removeFilter() {
    this.setState({ selectedFilterKey: '', selectedValue: '' }, this.props.onRemove());
  }
  _matchUUIDs(uuidList, value) {
    return (
      uuidList.uuid.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
      uuidList.dev_id.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  render() {
    const self = this;
    const { filters, filterAttributes } = self.props;


    let availableFilters = [
      <MenuItem key="filter-placeholder" value="" disabled>
        Filter by
      </MenuItem>
    ];

    const currentFilter = filterAttributes.find(item => item.key === self.state.selectedFilterKey);
    if (currentFilter) {
      availableFilters = [
        <MenuItem key="currentValue" value={currentFilter.key}>
          {currentFilter.value}
        </MenuItem>
      ];
    } else {
      availableFilters = filters.reduce((accu, item) => {
        accu.push(
          <MenuItem key={item.key} value={item.key}>
            {item.value}
          </MenuItem>
        );
        return accu;
      }, availableFilters);
    }

    return (
      <ListItem className="filterPair">
        <ListItemText>
          <TextField
            select
            value={self.state.selectedFilterKey}
            label="Filter by"
            onChange={event => self.setState({ selectedFilterKey: event.target.value })}
            InputProps={{
              endAdornment: self.state.selectedFilterKey ? (
                <InputAdornment position="end">
                  <IconButton onClick={() => self._removeFilter()}>
                    <RemoveCircleIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          >
            {availableFilters}
          </TextField>
          <Autocomplete
            id='uuids'
            options={this.props.attributeValues}
            getOptionLabel={option => option.uuid}
            style={{ width: 360 }}
            value={self.state.selectedValue}
            inputValue={self.state.selectedValue}
            disabled={!self.state.selectedFilterKey}
            onChange={(event, newValue) => {
              this.setState({ selectedValue:newValue?newValue.uuid:'' });
              self._updateFilterValue(newValue);
            }}
            onInputChange={(e) => {
              if(e && e.target && e.target.value !== 0 && e.key !== 'Enter') {
                self.setState({ selectedValue: e.target.value});
              }
            }}
            renderInput={params => {
              return (
                <TextField {...params} label="Select UUID" margin="normal" fullWidth />
              )}
            }
          />
        </ListItemText>
      </ListItem>
    );
  }
}
